module.exports = __webpack_public_path__ + "media/teacher/components/GetStarted/images/curve-79685ccb9f9cb75f1977ed028057622e.png";